import { render, staticRenderFns } from "./AdvisorApproveDetail.vue?vue&type=template&id=ff6e5982&"
import script from "./AdvisorApproveDetail.vue?vue&type=script&lang=js&"
export * from "./AdvisorApproveDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports